import axios from "axios";
import { AppConfig } from "./../../../AppConfig.js";

const appleWalletFunctionApiBaseUrl = AppConfig.appleWalletFunctionApiBaseUrl;
const googleWalletFunctionApiBaseUrl = AppConfig.googleWalletFunctionApiBaseUrl;

const instance = axios.create({
    baseURL: googleWalletFunctionApiBaseUrl,
    headers: {
        "Access-Control-Allow-Origin": "*"
    }
});
export async function getGoogleToken(userId, storeId) {
    return instance.get(`api/GoogleWallet/${storeId}/${userId}`);
}

export function getAppleAPIUrl(userId, storeId) {
    return appleWalletFunctionApiBaseUrl + `api/AppleWallet/${storeId}/${userId}`;
}
